import { FC } from "react";

import { Box, chakra } from "@chakra-ui/react";

import { FormMessage } from "@components/common";
import Image from "@components/Image";
import { OptionButtonGroup } from "@components/OptionButton";
import type { TOptionGroupItem } from "@components/OptionButton/types";
import { useFeatureData } from "@modules/features";
import { SWEDBANK_API } from "@modules/features/constants";

import type { TPaymentMethod } from "../types";

type TPaymentMethodsProps = {
  name: string;
  paymentMethods: TPaymentMethod[];
  fieldError?: string;
};

const getPaymentMethodOption = (
    paymentMethod: TPaymentMethod,
    swedBankPaymentMethodEnabled: boolean | undefined
): TOptionGroupItem => ({
  label: paymentMethod.logo ? (
      swedBankPaymentMethodEnabled && paymentMethod.code !== 'cardpayments' ? (
          <div
              style={{
                width: '112px',
                height: '53px',
                margin: '10px',
                padding: '5px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                boxSizing: 'border-box',
              }}
          >
            <Image
                src={paymentMethod.logo}
                alt={paymentMethod.name || ""}
                width={112}
                height={53}
                style={{ objectFit: 'contain' }}
            />
          </div>
      ) : paymentMethod.code === 'cardpayments' ? (
          <div style={{ padding: '10px' }}>
              <Image
                  src={paymentMethod.logo}
                  alt={paymentMethod.name || ""}
                  width={112}
                  height={40}
                  style={{ objectFit: 'contain' }}
              />
          </div>
      ) : (
          <Image
              src={paymentMethod.logo}
              alt={paymentMethod.name || ""}
              width={112}
              height={40}
              style={{ objectFit: 'contain' }}
          />
      )
  ) : (
      <chakra.span whiteSpace="initial">{paymentMethod.name}</chakra.span>
  ),
  value: paymentMethod.code,
  sx: { padding: 0 },
});

const PaymentMethodsField: FC<TPaymentMethodsProps> = ({name, paymentMethods, fieldError}) => {
  const features = useFeatureData();
  const swedBankPaymentMethodEnabled = features?.includes(SWEDBANK_API);
  const paymentOptions = paymentMethods.map((paymentMethod) =>
      getPaymentMethodOption(paymentMethod, swedBankPaymentMethodEnabled)
  );
  return (
      <Box py="0.5rem">
        {swedBankPaymentMethodEnabled ? (
            <OptionButtonGroup name={name} options={paymentOptions} width={112} height={53}/>
        ) : (
            <OptionButtonGroup name={name} options={paymentOptions}/>
        )}
        {fieldError && <FormMessage message={fieldError} isInvalid />}
    </Box>
  );
};
export default PaymentMethodsField;
